/* =====================================================================
   NUARA — VITRINE v3 · moteur commun (29/09/2026)
   Peu d'effets, parfaitement exécutés :
   - apparitions sobres [data-r] (texte) et [data-r="img"] (rideau + léger zoom arrière des photos) ;
   - le trait de baume (.nx-trait) qui se trace sous un mot clé ;
   - scènes épinglées [data-nx-scene] : --p (0 → 1) + el.__nxScene(p) ;
   - rails horizontaux [data-nx-rail] avec barre de progression.
   Respecte prefers-reduced-motion. Aucun import() (le minifieur Shopify le casse).
   ===================================================================== */
(function (w, d) {
  'use strict';
  var html = d.documentElement;
  html.classList.add('nx-js');
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }

  /* ---------- Apparitions ---------- */
  // Le rideau des photos passe par clip-path : Chromium ignore l'intersection d'un élément « clipé » à 100 %,
  // on observe donc son parent et on relaie la classe.
  var targets = typeof WeakMap === 'function' ? new WeakMap() : null;
  var io = 'IntersectionObserver' in w ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var list = (targets && targets.get(e.target)) || [e.target];
      list.forEach(function (el) { el.classList.add('is-in'); });
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;
  function observe(root) {
    $$('[data-r]:not(.is-in), .nx-trait:not(.is-in)', root).forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      var t = el.getAttribute('data-r') === 'img' && el.parentElement ? el.parentElement : el;
      // la liste d'une cible contient toujours la cible elle-même si elle est aussi à révéler (parent [data-r] d'une photo [data-r="img"])
      if (targets) { var l = targets.get(t) || []; if (l.indexOf(el) < 0) l.push(el); targets.set(t, l); }
      io.observe(t);
    });
  }

  /* ---------- Scènes épinglées ---------- */
  var scenes = [], ticking = false;
  function collect() { scenes = $$('[data-nx-scene]'); }
  function frame() {
    ticking = false;
    var vh = w.innerHeight;
    scenes.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      // scène plus haute que l'écran : progression de l'épinglage ; élément court : progression de son entrée à l'écran
      var p = r.height > vh ? clamp(-r.top / (r.height - vh), 0, 1) : clamp((vh - r.top) / (r.height * 1.5), 0, 1);
      if (el.__nxP === p) return; el.__nxP = p;
      el.style.setProperty('--p', p.toFixed(4));
      if (typeof el.__nxScene === 'function') el.__nxScene(p);
    });
  }
  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }

  /* ---------- Rails ---------- */
  function initRails(root) {
    $$('[data-nx-rail]:not([data-rail-ok])', root).forEach(function (rail) {
      rail.setAttribute('data-rail-ok', '1');
      var bar = rail.parentElement && rail.parentElement.querySelector('.nx-rail-bar i'); if (!bar) return;
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth, vis = rail.clientWidth / Math.max(1, rail.scrollWidth);
        bar.style.width = (vis * 100).toFixed(1) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0).toFixed(1) + '%)';
        bar.parentElement.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
      rail.addEventListener('scroll', upd, { passive: true }); w.addEventListener('resize', upd); upd();
    });
  }

  function init(root) { observe(root); initRails(root); collect(); frame(); }
  w.NX = { onScroll: onScroll, refresh: function () { collect(); frame(); }, clamp: clamp, reduce: reduce };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', function () { collect(); onScroll(); });
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})(window, document);
